<template v-if="storySelected && pageSelected && pageSelected.isNative">
    <div class="btn highlight" @click="$emit('click')">
        <div 
            v-if="highlight" 
            class="container-img" 
            :style="{backgroundColor : storySelected.background.color}"
        >
            <img 
                v-if="highlight.id && highlight.data" 
                :src="highlight.data.img"
            >
                
            <template v-else-if="storySelected.background.file">
                <img 
                    v-if="storySelected.background.file.info.type2 == 'image'" 
                    :src="storySelected.background.file.url"
                >
                <video 
                    v-else-if="storySelected.background.file.info.type2 == 'video'" 
                    :src="storySelected.background.file.url" 
                    :type="storySelected.background.file.info.type" 
                    preload="metadata" 
                    class="source" 
                    onloadedmetadata="true"
                    muted loop playsinline 
                />

            </template>
        </div>
        <img :src="require('@/assets/img/instagram/instagram_story_highlight_filled_32.png')">
    </div>
</template>

<script>
    import { VueDraft } from '@mashupweb/draft-lib'
    import { Story } from '@mashupweb/draft-lib/dist/form/story/entities/story';
    import StoryForm from '@mashupweb/draft-lib/dist/form/story/Form';

    export default {
        props: {
            formInstance:StoryForm,
            storySelected:Story
        },

        computed: {
            pageSelected() {
                if (this.formInstance.merge.target.id) {
                    return this.formInstance.merge.target;
                }
                return null;
            },
            highlight() {
                if (this.pageSelected && this.storySelected) {
                    return this.storySelected.highlights?.[this.pageSelected.id];
                }
                return null;
            },

        }
    }
</script>

<style lang="scss" scoped>


</style>